import React from 'react';
import CloudIcon from '@mui/icons-material/Cloud';
import CodeIcon from '@mui/icons-material/Code';
import StorageIcon from '@mui/icons-material/Storage';
import PsychologyIcon from '@mui/icons-material/Psychology';
import HubIcon from '@mui/icons-material/Hub';
import SecurityIcon from '@mui/icons-material/Security';
import SpeedIcon from '@mui/icons-material/Speed';
import SyncIcon from '@mui/icons-material/Sync';
import WebhookIcon from '@mui/icons-material/Webhook';
import ScheduleIcon from '@mui/icons-material/Schedule';
import ApiIcon from '@mui/icons-material/Api';
import BusinessIcon from '@mui/icons-material/Business';
import GroupsIcon from '@mui/icons-material/Groups';
import MemoryIcon from '@mui/icons-material/Memory';

const tagIconMap: Record<string, React.ReactNode> = {
  Java: <CodeIcon sx={{ fontSize: 14 }} />,
  PHP: <CodeIcon sx={{ fontSize: 14 }} />,
  React: <CodeIcon sx={{ fontSize: 14 }} />,
  'Node.js': <HubIcon sx={{ fontSize: 14 }} />,
  TypeScript: <CodeIcon sx={{ fontSize: 14 }} />,
  Python: <CodeIcon sx={{ fontSize: 14 }} />,
  AWS: <CloudIcon sx={{ fontSize: 14 }} />,
  Architecture: <BusinessIcon sx={{ fontSize: 14 }} />,
  'CI/CD': <SyncIcon sx={{ fontSize: 14 }} />,
  Playwright: <CodeIcon sx={{ fontSize: 14 }} />,
  Monitoring: <SpeedIcon sx={{ fontSize: 14 }} />,
  OAuth: <SecurityIcon sx={{ fontSize: 14 }} />,
  Sync: <SyncIcon sx={{ fontSize: 14 }} />,
  Webhooks: <WebhookIcon sx={{ fontSize: 14 }} />,
  Cron: <ScheduleIcon sx={{ fontSize: 14 }} />,
  APIs: <ApiIcon sx={{ fontSize: 14 }} />,
  ERP: <BusinessIcon sx={{ fontSize: 14 }} />,
  CRM: <GroupsIcon sx={{ fontSize: 14 }} />,
  SaaS: <CloudIcon sx={{ fontSize: 14 }} />,
  'Multi-tenant': <BusinessIcon sx={{ fontSize: 14 }} />,
  RBAC: <SecurityIcon sx={{ fontSize: 14 }} />,
  SQL: <StorageIcon sx={{ fontSize: 14 }} />,
  CDN: <CloudIcon sx={{ fontSize: 14 }} />,
  Caching: <MemoryIcon sx={{ fontSize: 14 }} />,
  'Query tuning': <SpeedIcon sx={{ fontSize: 14 }} />,
  'Audit logs': <SecurityIcon sx={{ fontSize: 14 }} />,
  Validation: <SecurityIcon sx={{ fontSize: 14 }} />,
  AI: <PsychologyIcon sx={{ fontSize: 14 }} />,
};

export function TagWithIcon({ tag }: { tag: string }) {
  return (
    <span className="inline-flex items-center gap-1 text-xs text-ink-secondary">
      <span className="text-ink-muted opacity-70">{tagIconMap[tag] ?? <CodeIcon sx={{ fontSize: 14 }} />}</span>
      {tag}
    </span>
  );
}

export function TagIconRow({ tags }: { tags: string[] }) {
  return (
    <div className="flex flex-wrap gap-x-3 gap-y-1.5">
      {tags.map((tag) => (
        <TagWithIcon key={tag} tag={tag} />
      ))}
    </div>
  );
}
